import PropTypes from 'prop-types';
/* eslint-disable eqeqeq */
import { LeftOutlined } from '@ant-design/icons';
import { useState, useEffect } from 'react';
import { Layout, Menu } from 'antd';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Icono from 'components/Icono/Icono';
import './Menus.scss';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { PROCESOS_ELECTORALES } from 'constants/nombresCatalogos';
import { Loader } from '../Loader/Loader';
import styles from '../FullLoader/FullLoader.styles';

const Container = styled.div`
  ${styles}
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  flex: 1;
  justify-content: center;
  padding-left: 0px;
`;
let rutaItem = '';
const { Sider } = Layout;
const itemsm = [];
export const getItem = (label, key, icon, children, url, className) => {
  return {
    key,
    icon,
    children,
    label,
    url,
    className
  };
};

export const getItemP = (label, key, children) => {
  return {
    key,
    children,
    label
  };
};

export const getItemj = (label, key, icon, url) => {
  return {
    label,
    key,
    icon,
    url
  };
};
const addAnimation = (name) => {
  return (
    <label className="swipe-animation" htmlFor="name">
      {name}
    </label>
  );
};

const menuDinamico = (data) => {
  itemsm.length = 0;
  let hijos = [];
  data.map((x) => {
    if (x.nombre === 'Inicio' && x.idMenu === 12) {
      if (x.subMenus != null && x.subMenus.length != 0) {
        hijos = [];
        x.subMenus.map((y) => hijos.push(getItemj(y.nombre, y.nombre, '', y.url)));
        itemsm.push(
          getItem(x.nombre, 1, <Icono iconName="home" size={24} paddingRight={24} />, hijos, x.url)
        );
      } else {
        itemsm.push(
          getItemj(x.nombre, 1, <Icono iconName="home" size={24} paddingRight={24} />, x.url)
        );
      }
    }

    if (x.nombre === 'Cuentas de Usuario' && x.idMenu === 8) {
      if (x.subMenus != null && x.subMenus.length != 0) {
        hijos = [];
        x.subMenus.map((y) => hijos.push(getItemj(addAnimation(y.nombre), y.nombre, '', y.url)));
        itemsm.push(
          getItem(
            addAnimation(x.nombre),
            2,
            <Icono iconName="group" size={24} paddingRight={24} />,
            hijos,
            x.url
          )
        );
      } else {
        itemsm.push(
          getItemj(
            addAnimation(x.nombre),
            2,
            <Icono iconName="group" size={24} paddingRight={24} />,
            x.url
          )
        );
      }
    }

    if (x.nombre === 'Dispositivos' && x.idMenu === 9) {
      if (x.subMenus != null && x.subMenus.length != 0) {
        hijos = [];
        x.subMenus.map((y) => hijos.push(getItemj(y.nombre, y.nombre, '', y.url)));
        itemsm.push(
          getItem(
            x.nombre,
            3,
            <Icono iconName="phone_iphone" size={24} paddingRight={24} />,
            hijos,
            x.url
          )
        );
      } else {
        itemsm.push(
          getItemj(
            x.nombre,
            3,
            <Icono iconName="phone_iphone" size={24} paddingRight={24} />,
            x.url
          )
        );
      }
    }

    if (x.nombre === 'Geocercas' && x.idMenu === 5) {
      if (x.subMenus.length > 0) {
        hijos = [];
        x.subMenus.map((y) => hijos.push(getItemj(y.nombre, y.nombre, '', y.url)));
        itemsm.push(
          getItem(
            x.nombre,
            4,
            <Icono iconName="pin_drop" size={24} paddingRight={24} />,
            hijos,
            x.url
          )
        );
      } else {
        itemsm.push(
          getItemj(x.nombre, 4, <Icono iconName="pin_drop" size={24} paddingRight={24} />, x.url)
        );
      }
    }

    if (x.nombre === 'Espectaculares' && x.idMenu === 1) {
      if (x.subMenus != null && x.subMenus.length != 0) {
        hijos = [];
        x.subMenus.map((y) => {
          if (y.nombre === 'Propaganda en vía pública') {
            hijos.push(getItemj(addAnimation(y.nombre), y.nombre, '', y.url));
          } else {
            hijos.push(getItemj(y.nombre, y.nombre, '', y.url));
          }
          return y;
        });

        itemsm.push(
          getItem(
            addAnimation(x.nombre),
            5,
            <Icono iconName="tv" size={24} paddingRight={24} />,
            hijos,
            x.url
          )
        );
      } else {
        itemsm.push(
          getItemj(x.nombre, 5, <Icono iconName="tv" size={24} paddingRight={24} />, x.url)
        );
      }
    }

    if (x.nombre === 'Internet' && x.idMenu === 3) {
      if (x.subMenus.length > 0) {
        hijos = [];
        x.subMenus.map((y) => hijos.push(getItemj(y.nombre, y.nombre, '', y.url)));
        itemsm.push(
          getItem(
            x.nombre,
            6,
            <Icono iconName="language" size={24} paddingRight={24} />,
            hijos,
            x.url
          )
        );
      } else {
        itemsm.push(
          getItemj(x.nombre, 6, <Icono iconName="language" size={24} paddingRight={24} />, x.url)
        );
      }
    }

    if (x.nombre === 'Medios impresos' && x.idMenu === 2) {
      if (x.subMenus.length > 0) {
        hijos = [];
        x.subMenus.map((c) => hijos.push(getItemj(c.nombre, c.nombre, '', c.url)));
        itemsm.push(
          getItem(
            x.nombre,
            7,
            <Icono iconName="library_books" size={24} paddingRight={24} />,
            hijos,
            x.url
          )
        );
      } else {
        itemsm.push(
          getItemj(
            x.nombre,
            // addAnimation(x.nombre),
            7,
            <Icono iconName="library_books" size={24} paddingRight={24} />,
            x.url
          )
        );
      }
    }

    if (x.nombre === 'Visitas verificación' && x.idMenu === 4) {
      if (x.subMenus != null && x.subMenus.length != 0) {
        hijos = [];
        x.subMenus.map((y) => hijos.push(getItemj(y.nombre, y.nombre, '', y.url)));
        itemsm.push(
          getItem(
            addAnimation(x.nombre),
            8,
            <Icono iconName="badge" size={24} paddingRight={24} />,
            hijos,
            x.url
          )
        );
      } else {
        itemsm.push(
          getItemj(x.nombre, 8, <Icono iconName="badge" size={24} paddingRight={24} />, x.url)
        );
      }
    }

    if (x.nombre === 'Descargas' && x.idMenu === 10) {
      if (x.subMenus != null && x.subMenus.length != 0) {
        hijos = [];
        x.subMenus.map((y) => {
          if (y.nombre === 'Generación de enlaces') {
            hijos.push(getItemj(addAnimation(y.nombre), y.nombre, '', y.url));
          } else {
            hijos.push(getItemj(y.nombre, y.nombre, '', y.url));
          }
          return y;
        });
        itemsm.push(
          getItem(
            x.nombre,
            9,
            <Icono iconName="download_for_offline" size={24} paddingRight={24} />,
            hijos,
            x.url
          )
        );
      } else {
        itemsm.push(
          getItemj(
            x.nombre,
            9,
            <Icono iconName="download_for_offline" size={24} paddingRight={24} />,
            x.url
          )
        );
      }
    }

    if (x.nombre === 'Reportes' && x.idMenu === 6) {
      if (x.subMenus != null) {
        hijos = [];
        x.subMenus.map((y) => {
          if (y.nombre === 'Bitacora de Sincronización ') {
            hijos.push(getItemj(addAnimation(y.nombre), y.nombre, '', y.url));
          } else {
            hijos.push(getItemj(y.nombre, y.nombre, '', y.url));
          }
          return y;
        });
        itemsm.push(
          getItem(
            x.nombre,
            10,
            <Icono iconName="sticky_note_2" size={24} paddingRight={24} />,
            hijos,
            x.url
          )
        );
      } else {
        itemsm.push(
          getItemj(
            x.nombre,
            10,
            <Icono iconName="sticky_note_2" size={24} paddingRight={24} />,
            x.url
          )
        );
      }
    }

    if (x.nombre === 'Configuración de catálogos' && x.idMenu === 13) {
      if (x.subMenus != null && x.subMenus.length != 0) {
        hijos = [];
        x.subMenus.map((y) => {
          if (y.nombre === 'Catálogo de Medios impresos') {
            hijos.push(getItemj(addAnimation(y.nombre), y.nombre, '', y.url));
          } else {
            hijos.push(getItemj(y.nombre, y.nombre, '', y.url));
          }
          return y;
        });
        itemsm.push(
          getItem(
            addAnimation(x.nombre),
            11,
            <Icono iconName="folder" size={24} paddingRight={24} />,
            hijos,
            x.url
          )
        );
      } else {
        itemsm.push(
          getItemj(
            addAnimation(x.nombre),
            11,
            <Icono iconName="folder" size={24} paddingRight={24} />,
            x.url
          )
        );
      }
    }

    if (x.nombre === 'Edición de plantillas' && x.idMenu === 14) {
      if (x.subMenus !== null && x.subMenus.length !== 0) {
        hijos = [];
        x.subMenus.map((y) => hijos.push(getItemj(addAnimation(y.nombre), y.nombre, '', y.url)));
        itemsm.push(
          getItem(
            x.nombre,
            12,
            <Icono iconName="receipt_long" size={24} paddingRight={24} />,
            hijos,
            x.url
          )
        );
      } else {
        itemsm.push(
          getItemj(
            // x.nombre,
            addAnimation(x.nombre),
            12,
            <Icono iconName="receipt_long" size={24} paddingRight={24} />,
            x.url
          )
        );
      }
    }

    if (x.nombre === 'Centro de ayuda' && x.idMenu === 11) {
      if (x.subMenus != null && x.subMenus.length != 0) {
        hijos = [];
        x.subMenus.map((y) => hijos.push(getItemj(y.nombre, y.nombre, '', y.url)));
        itemsm.push(
          getItem(
            x.nombre,
            13,
            <Icono iconName="help" size={24} color="#c12b7d" paddingRight={24} />,
            hijos,
            x.url
          )
        );
      } else {
        itemsm.push(
          getItemj(
            x.nombre,
            13,
            <Icono iconName="help" size={24} color="#c12b7d" paddingRight={24} />,
            x.url
          )
        );
      }
    }
    return itemsm.sort((a, b) => a.key - b.key);
  });
};

export function Menus({ currentPath }) {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(true);
  const [selectedKeys, setSelectedKeys] = useState(['1']);
  const [openKeys, setOpenKeys] = useState(['sub1']);
  const catProcesosElectorales = useSelector(selectCatalogByName(PROCESOS_ELECTORALES));
  const [loadingCatalogos, setLoadingCatalogos] = useState(true);

  const handleClick = (e) => {
    setSelectedKeys([e?.key]);
    // eslint-disable-next-line no-unused-vars
    const ruta = itemsm.map((x) => {
      try {
        if (x?.key == e.key) {
          if (x?.key == e.key) {
            rutaItem = x.url;
            return x.url;
          }
        }
        if (x.children != null && x.children.length != 0) {
          // eslint-disable-next-line no-unused-vars, consistent-return, array-callback-return
          const ruta2 = x.children.map((y) => {
            if (y?.key == e.key) {
              rutaItem = y.url;
              return y.url;
            }
          });
        }
        return '';
      } catch (error) {
        return '';
      }
    });
    navigate(rutaItem);
  };

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  };

  useEffect(() => {
    if (catProcesosElectorales !== undefined && catProcesosElectorales.length > 0) {
      setLoadingCatalogos(false);
    }
  }, [catProcesosElectorales]);

  useEffect(() => {
    if (itemsm.length > 0 && currentPath) {
      const separetePath = currentPath.split('/');
      const requiredPath =
        separetePath.length > 3 ? separetePath.slice(1, 3).join('/') : currentPath.slice(1);
      const path = itemsm.find((item) => item.url === requiredPath);
      if (separetePath.length > 3 && path?.children?.length > 0) {
        const pathChildren = path.children.find((item) => item.url === currentPath.slice(1));
        setSelectedKeys([pathChildren?.key]);
      } else {
        setSelectedKeys([path?.key.toString()]);
      }
    }
  }, [currentPath]);

  return (
    <Layout
      style={{
        minHeight: '100vh',
        textAlign: LeftOutlined,
        paddingLeft: '0px'
      }}>
      <Sider
        style={{ background: '#293846', color: '#FFFFFF', paddingLeft: '0px', height: '100%' }}
        collapsible
        collapsed={collapsed}
        // eslint-disable-next-line no-unused-vars
        onCollapse={(value) => {
          setCollapsed(value);
          if (value) {
            setOpenKeys([]); // Colapsa los submenús cuando el sider está colapsado
          } else {
            setOpenKeys(['sub1']); // Mantiene el submenú abierto cuando el sider no está colapsado
          }
        }}>
        <Menu
          style={{ background: '#293846', color: '#FFFFFF', paddingLeft: '0px' }}
          selectedKeys={selectedKeys}
          mode="inline"
          items={itemsm}
          onClick={(e) => handleClick(e)}
          openKeys={openKeys}
          onOpenChange={onOpenChange}
        />
      </Sider>
      <StyledContainer>
        {loadingCatalogos ? (
          <Container style={{ width: '100%' }}>
            <Loader size="large" />
          </Container>
        ) : (
          <Outlet />
        )}
      </StyledContainer>
    </Layout>
  );
}

export default menuDinamico;

Menus.propTypes = {
  currentPath: PropTypes.string
};

Menus.defaultProps = {
  currentPath: null
};
